import styled from "styled-components";
import { IMessageStyleProps } from "./interfaces";

export const Wrapper = styled.div`
    [class^="User__UserImage"] {
        margin-right: 6px;
    }
`;

export const UserWrapper = styled.div`
    pointer-events: none;
`;

export const MessageWrapper = styled.div<IMessageStyleProps>`
    display: flex;
    justify-content: ${p => (p.isOwnMessage ? "flex-end" : "flex-start")};
    margin-right: 6px;
`;

export const Message = styled.div<IMessageStyleProps>`
    padding: 6px 8px;
    border-radius: 12px;
    background-color: ${p => (p.isOwnMessage ? p.theme.c.active : p.theme.c.greyE)};
    color: ${p => (p.isOwnMessage ? p.theme.c.white : p.theme.c.dark)};
    margin: 6px 0;
    font-size: 14px;
    line-height: 16px;
    word-break: break-word;
`;
